module.exports = __webpack_public_path__ + "img/code.ee0be3f1.png";